import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["digito", "input"]

  static values = {
    url: String,
    nextUrl: String,
    tamanho: Number
  }

  connect() {
    console.log("TecladoCodigoController conectado")
    this.codigo = []
    this.bloqueado = false
    this.render()
  }

  pressionar(event) {
    if (this.bloqueado) return
    if (this.codigo.length >= this.tamanhoValue) return

    const key = event.currentTarget.dataset.key
    this.codigo.push(key)

    this.render()

    if (this.codigo.length === this.tamanhoValue) {
      this.submit()
    }
  }

  apagar() {
    if (this.bloqueado) return

    this.codigo.pop()
    this.render()
  }

  render() {
    this.digitoTargets.forEach((el, i) => {
      el.textContent = this.codigo[i] ? "●" : ""
    })

    this.inputTarget.value = this.codigo.join("")
  }

  submit() {
    this.bloqueado = true

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document
          .querySelector("meta[name=csrf-token]")
          .content
      },
      body: JSON.stringify({ codigo: this.codigo.join("") })
    })
      .then(async (response) => {
        const data = await response.json()

        if (!response.ok) {
          this.erro(data.error || "Código inválido")
          return
        }

        // código validado → navegação normal
        window.location.href = this.nextUrlValue
      })
      .catch(() => {
        this.erro("Erro de comunicação")
      })
      .finally(() => {
        this.bloqueado = false
      })
  }

  erro(mensagem) {
    console.warn("Erro:", mensagem)

    // ativa estado visual
    this.element.classList.add("ui-teclado-codigo--erro")

    // limpa código
    this.codigo = []
    this.render()

    // remove estado visual após animação
    setTimeout(() => {
      this.element.classList.remove("ui-teclado-codigo--erro")
    }, 1200)
  }
}
